import {cssVar} from '@chakra-ui/react'

const $accentColor = cssVar('stepper-accent-color')

/**
 * check the source for the base theme
 * @template {import('@chakra-ui/theme/dist/components/stepper.js')} CHAKRA_BASE_THEME
 */
export default {
    baseStyle: {
        stepper: {
            [$accentColor.variable]: 'colors.stokkeFunctional.alertGreen'
        },
        step: {},
        title: {
            display: {base: 'none', md: 'block'}
        },
        description: {},
        indicator: {},
        separator: {},
        icon: {},
        number: {}
    }
}
